module.exports = __webpack_public_path__ + "b4ea59843354b7d5e604464972bd6ec0.MP3";